module.exports = __webpack_public_path__ + "static/img/htjs2.2ab605e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/htjs2.png
// module id = UpmS
// module chunks = 1